module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ActivityReviews"
  }, [_c('div', {
    staticClass: "m-t-2 row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.t('Reviews')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.reviews()), function(review) {
    return _c('div', {
      staticClass: "col-md-12 col-lg-6 col-xl-4  m-t-2 reviewContainer"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-block"
    }, [_c('div', {
      staticClass: "review m-b-3 sameHeight"
    }, [_c('p', [_c('span', {
      staticClass: "h4"
    }, [_vm._v(_vm._s(review.name))]), _vm._v(" "), _vm._m(0, true), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "timeAgo"
    }, [_vm._v("(" + _vm._s(review.timeAgo) + ")")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(review.text))])])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "stars"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star-o"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d1adab6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d1adab6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/ActivityReviews.vue
// module id = 763
// module chunks = 3